<template>
  <div>
    <vx-card class="relative">
            <div v-if="!completed">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <!-- <vs-button @click="goBack" color="primary" type="border"
              >Back</vs-button
            > -->
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="9"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>{{campaignDescription.campaign_name}} Contacts</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="4"
            vs-xs="12"
          >
          
           
          </vs-col>
        </vs-row>
      </div>
      <template>
        <h3 class="text-dark-grey mb-16 text-center">
          We still have unmatched contacts. What would you like to do?
        </h3>
        <div class="vx-row mb-10">

          <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
            <router-link to="/contacts/add">
              <vx-card>
                <vs-row vs-w="12" class="">
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="10"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <feather-icon
                      icon="BookIcon"
                      svgClasses="h-4 w-4"
                      class="mr-3"
                    />
                    <h5>Enter a new contact int the master database?</h5>
                  </vs-col>
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                </vs-row>
              </vx-card>
            </router-link>
          </div>

          <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
            <router-link :to="export_link">
              <vx-card>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="10"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <feather-icon
                      icon="MapIcon"
                      svgClasses="h-4 w-4"
                      class="mr-3"
                    />
                    <h5>Export unmatched records from the CSV table?</h5>
                  </vs-col>
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                </vs-row>
              </vx-card>
            </router-link>
          </div>
          <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
            <router-link to="/dashboard">
              <vx-card>
                <vs-row vs-w="12">
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="10"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <feather-icon
                      icon="FigmaIcon"
                      svgClasses="h-4 w-4"
                      class="mr-3"
                    />
                    <h5>Nothing, I will come back to this later</h5>
                  </vs-col>
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                </vs-row>
              </vx-card>
            </router-link>
          </div>
        </div>

         <div class="vx-row mb-10">

          <!-- <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
              
            <vx-card>
              <vs-row vs-w="12">
                <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="10"
                  vs-sm="4"
                  vs-xs="12"
                >
                 <feather-icon
                    icon="EditIcon"
                    svgClasses="h-4 w-4"
                    class="mr-3"
                  />
                      <vs-button
            @click="write_unmatched_to_master_db_and_campaign()"
            color="white"
            ><h5 style="color:black;">Write unmatched contacts to the master database and add them to the campaign</h5></vs-button
          >
                 
                </vs-col>
                <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                </vs-col>
              </vs-row>
            </vx-card>
        </div> -->

            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
            <router-link :to="enrich_contact_to_master_db_link">
              <vx-card>
                <vs-row vs-w="12" class="">
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="10"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <feather-icon
                      icon="BookIcon"
                      svgClasses="h-4 w-4"
                      class="mr-3"
                    />
                    <h5>Update matched contact data to master database.</h5>
                  </vs-col>
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                </vs-row>
              </vx-card>
            </router-link>
          </div>
<!-- 
          <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
            <router-link :to="enrich_contact_field_data_to_master_db_link">
              <vx-card>
                <vs-row vs-w="12" class="">
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="10"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <feather-icon
                      icon="BookIcon"
                      svgClasses="h-4 w-4"
                      class="mr-3"
                    />
                    <h5>Enrich matched contact field data to master database.</h5>
                  </vs-col>
                  <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
                  </vs-col>
                </vs-row>
              </vx-card>
            </router-link>
          </div> -->

       
            <div class="vx-row mb-10">
         

       
       
        </div>
        </div>
      </template>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import axios from "@/axios.js";
export default {
  data() {
    return {
      enrich_contact_field_data_to_master_db_link:null,
      user_id:null,
      user_role:null,
      campaignDescription:[],
      export_link:null,
      enrich_contact_to_master_db_link:null,
      abilities : null,
      campaignId:null,
      completed: false,

    };
  },
  mounted() {
        this.getCampaignDescription()
      this.export_link = "/contacts/remain_unmatched/" + this.campaignId;
    this.enrich_contact_to_master_db_link = '/contacts/enrichContactDataToMasterDb/' + this.campaignId
    this.enrich_contact_field_data_to_master_db_link = '/contacts/enrichContactFieldDataToMasterDb/' + this.campaignId

  },
  watch: {
    
  },
  methods: {
write_unmatched_to_master_db_and_campaign() {


       this.$vs.dialog({
        title: `Confirm`,
        type: "confirm",
        color: "danger",
        text: `The unmatched contacts will be added on the master contacts and also added to the campaign. Please accept to confirm.`,
        accept: this.writeData,
        acceptText: "Accept"
      });


     

    },
    writeData(){



      this.$vs.loading();

      axios
        .post(this.$base_url + "/api/contacts/write_unmatched_contacts_to_master_db_and_campaign", {
          campaignId: this.campaignId,
          user_id: this.user_id
        })
        .then(response => {
if(response.data.status == 'success'){
            this.$vs.notify({
              color: "success",
              title: "Contacts Added To Campaign",
              text: response.data.message
            });
            this.$vs.loading.close();
          }


    
        })
        .catch(error => {
          console.log(error);
        });

    },
    goBack: function() {
      this.$router.go(-1);
    },
            getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
  },
  created(){
    var self = this
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    self.user_role = userInfo["userRole"];
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });  
     if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;
    console.log(this.campaignId)
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.searchbox {
  padding: 10px 21px;
  width: 600px;
}

.relative {
  /* position: fixed !important; */
  z-index: 999;
  /* width: 98.5%; */
}

.vxtable {
  /* position: absolute !important; */
  margin-top: 20px;
}
</style>
